import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { MatMenuModule } from "@angular/material/menu";
import { TranslocoModule } from "@jsverse/transloco";
import { LorenDashboardRoutingModule } from "./loren-dashboard-routing.module";
import { LorenDashboardComponent } from "./components/loren-dashboard/loren-dashboard.component";
import { LorenKeyValueControlModule } from "../../shared/modules/loren-key-value-control/loren-key-value-control.module";
import { LorenAllAssetResolver } from "../loren-assets/resolvers/loren-asset-all.resolver";
import { LorenDateModule } from "../../shared/pipes/loren-date/loren-date.module";
import { LorenDashboardWidgetsModalComponent } from "./components/loren-dashboard-widgets-modal/loren-dashboard-widgets-modal.component";
import { LorenImageModule } from "../../shared/pipes/loren-image/loren-image.module";
import { LorenWidgetColSizeResolverPipe } from "./components/loren-dashboard/pipes/loren-widget-col-size-resolver.pipe";
import { LorenDashboardCreateAssetStateComponent } from "./components/loren-dashboard-create-asset-state/loren-dashboard-create-asset-state.component";
import { LorenSharedDirectivesModule } from "../../shared/directives/loren-shared-directives.module";
import { LorenPageContentComponent } from "../../shared/modules/loren-page-content/loren-page-content.component";
import { LorenAssetCardComponent } from "../../shared/modules/loren-asset-card/loren-asset-card.component";
import { LorenFiltersComponent } from "../../shared/modules/loren-filters/loren-filters.component";

@NgModule({
  declarations: [
    LorenDashboardComponent,
    LorenDashboardWidgetsModalComponent,
    LorenWidgetColSizeResolverPipe,
    LorenDashboardCreateAssetStateComponent,
  ],
  exports: [LorenDashboardComponent],
  providers: [LorenAllAssetResolver],
  imports: [
    CommonModule,
    FormsModule,
    DragDropModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    MatGridListModule,
    MatMenuModule,
    MatPaginatorModule,
    MatProgressSpinner,
    MatTooltipModule,
    TranslocoModule,

    LorenKeyValueControlModule,
    LorenDashboardRoutingModule,
    LorenDateModule,
    LorenImageModule,
    LorenSharedDirectivesModule,

    LorenPageContentComponent,
    LorenAssetCardComponent,
    LorenFiltersComponent,
  ],
})
export class LorenDashboardModule {}
